import { NgModule }      from '@angular/core';
import { FunctionFactory, PluralizeService, WindowRef, UtilService, UndoRedoStack, TypeformService }   from '../';
import { LibraryInjectorService } from '../library-injector.service';
import { AppInternalSettings } from 'angular-framework-client-components/model/app-settings';


@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ 
    FunctionFactory, 
    PluralizeService, 
    TypeformService,
    AppInternalSettings, 
    WindowRef, 
    UtilService, 
    LibraryInjectorService, 
    UndoRedoStack 
    ],
  exports:      [ ],
})

export class OtherServicesModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/module/other.services.module.ts